import { render, staticRenderFns } from "./ascvdAssessment.vue?vue&type=template&id=7a9e0d1e&scoped=true"
import script from "./ascvdAssessment.vue?vue&type=script&lang=js"
export * from "./ascvdAssessment.vue?vue&type=script&lang=js"
import style0 from "./ascvdAssessment.vue?vue&type=style&index=0&id=7a9e0d1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9e0d1e",
  null
  
)

export default component.exports